/* ============================================================
   NOVAA GEAR — Accessory PDP behaviour
   Gallery thumbs · quantity · variant → price · sticky buy bar
   · bundle calculator. No dependencies.
   ============================================================ */
(function () {
  'use strict';

  var money = function (n) {
    return '$' + Math.round(n).toLocaleString('en-AU');
  };

  /* ============================================================
     GALLERY
     Event-delegated on `document` so it keeps working after the
     section is re-rendered (theme editor, view transitions,
     variant section-rendering). No captured element refs.
     ============================================================ */
  var GAL_SEL = '.section-accessory-pdp [data-gallery]';

  function galSlides(g) { return Array.prototype.slice.call(g.querySelectorAll('[data-gslide]')); }
  function galThumbs(g) { return Array.prototype.slice.call(g.querySelectorAll('[data-gthumb]')); }

  function galSelect(g, index) {
    var slides = galSlides(g);
    var n = slides.length;
    if (!n) return;
    index = ((index % n) + n) % n; /* wrap in both directions */

    slides.forEach(function (s, i) {
      var on = i === index;
      s.classList.toggle('is-active', on);
      if (!on) {
        var v = s.querySelector('video');
        if (v && !v.paused) { try { v.pause(); } catch (err) {} }
        var f = s.querySelector('iframe');
        if (f) { f.parentNode.removeChild(f); s.classList.remove('is-playing'); }
      }
    });

    galThumbs(g).forEach(function (t, i) {
      var on = i === index;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });

    g.setAttribute('data-gallery-index', String(index));

    var counter = g.querySelector('[data-gallery-counter]');
    if (counter) counter.textContent = (index + 1) + ' / ' + n;
  }

  function galStep(g, delta) {
    galSelect(g, (parseInt(g.getAttribute('data-gallery-index'), 10) || 0) + delta);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;

    var thumb = t.closest('[data-gthumb]');
    if (thumb) {
      var gt = thumb.closest('[data-gallery]');
      if (gt) { e.preventDefault(); galSelect(gt, parseInt(thumb.getAttribute('data-index'), 10) || 0); }
      return;
    }

    var prev = t.closest('[data-gallery-prev]');
    if (prev) {
      var gp = prev.closest('[data-gallery]');
      if (gp) { e.preventDefault(); galStep(gp, -1); }
      return;
    }

    var next = t.closest('[data-gallery-next]');
    if (next) {
      var gn = next.closest('[data-gallery]');
      if (gn) { e.preventDefault(); galStep(gn, 1); }
      return;
    }

    /* external (YouTube / Vimeo) media: build the iframe only on demand */
    var ext = t.closest('[data-gext-play]');
    if (ext) {
      e.preventDefault();
      var slide = ext.closest('[data-gslide]');
      if (!slide || slide.querySelector('iframe')) return;
      var host = (ext.getAttribute('data-gext-host') || '').toLowerCase();
      var vid = ext.getAttribute('data-gext-id') || '';
      if (!vid) return;
      var src = host === 'vimeo'
        ? 'https://player.vimeo.com/video/' + encodeURIComponent(vid) + '?autoplay=1'
        : 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(vid) + '?autoplay=1&rel=0';
      var frame = document.createElement('iframe');
      frame.setAttribute('src', src);
      frame.setAttribute('title', 'Product video');
      frame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
      frame.setAttribute('allowfullscreen', '');
      frame.setAttribute('loading', 'lazy');
      slide.appendChild(frame);
      slide.classList.add('is-playing');
    }
  }, false);

  /* left / right arrow keys while focus is inside a gallery */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var el = document.activeElement;
    if (!el || typeof el.closest !== 'function') return;
    var g = el.closest(GAL_SEL);
    if (!g) return;
    e.preventDefault();
    galStep(g, e.key === 'ArrowRight' ? 1 : -1);
  });

  /* swipe the main stage on touch devices */
  (function () {
    var sx = 0, sy = 0, sg = null;
    document.addEventListener('touchstart', function (e) {
      sg = null;
      var t = e.target;
      if (!t || typeof t.closest !== 'function' || !e.touches.length) return;
      if (!t.closest('[data-gallery-main]')) return;
      var g = t.closest(GAL_SEL);
      if (!g) return;
      sg = g; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });
    document.addEventListener('touchend', function (e) {
      if (!sg || !e.changedTouches.length) { sg = null; return; }
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) galStep(sg, dx < 0 ? 1 : -1);
      sg = null;
    }, { passive: true });
  })();

  document.querySelectorAll('.section-accessory-pdp').forEach(function (root) {

    /* ---------- QUANTITY ---------- */
    var qtyWrap = root.querySelector('[data-qty]');
    if (qtyWrap) {
      var qVal = qtyWrap.querySelector('[data-qty-value]');
      var qInput = qtyWrap.querySelector('[data-qty-input]');
      var setQ = function (n) {
        n = Math.max(1, n);
        qVal.textContent = n;
        if (qInput) qInput.value = n;
      };
      qtyWrap.querySelector('[data-qty-minus]').addEventListener('click', function () { setQ(parseInt(qVal.textContent, 10) - 1); });
      qtyWrap.querySelector('[data-qty-plus]').addEventListener('click', function () { setQ(parseInt(qVal.textContent, 10) + 1); });
    }

    /* ---------- VARIANT → PRICE ---------- */
    var idInput = root.querySelector('[data-variant-id-input]');
    var priceEl = root.querySelector('[data-price]');
    var afterpayEl = root.querySelector('[data-afterpay]');
    var bbPrice = root.querySelector('[data-bb-price]');
    var isoEl = priceEl ? priceEl.querySelector('small') : null;
    var iso = isoEl ? isoEl.textContent : '';
    root.querySelectorAll('input[name="variant-radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        if (idInput) idInput.value = radio.value;
        var p = radio.getAttribute('data-price') || '';
        if (priceEl) priceEl.innerHTML = p + (iso ? '<small>' + iso + '</small>' : '');
        if (bbPrice) bbPrice.textContent = p;
        // afterpay = price / 4
        var num = parseFloat(p.replace(/[^0-9.]/g, ''));
        if (afterpayEl && !isNaN(num)) afterpayEl.textContent = money(num / 4);
      });
    });

    /* ---------- STICKY BUY BAR ---------- */
    var bar = root.querySelector('[data-buybar]');
    var hero = root.querySelector('.pdp-hero');
    if (bar && hero && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          // show bar once the hero's ATC has scrolled out of view
          bar.classList.toggle('is-on', !e.isIntersecting);
        });
      }, { rootMargin: '-80px 0px 0px 0px', threshold: 0 });
      var atc = hero.querySelector('.atc-row') || hero;
      io.observe(atc);
    }

    /* ---------- BUNDLE CALCULATOR ---------- */
    var bundle = root.querySelector('[data-bundle]');
    if (bundle) {
      var rows = Array.prototype.slice.call(bundle.querySelectorAll('[data-bundle-row]'));
      var totalEl = bundle.querySelector('[data-bundle-total]');
      var saveEl = bundle.querySelector('[data-bundle-save]');
      var ctaTotalEl = bundle.querySelector('[data-bundle-cta-total]');

      var recompute = function () {
        var total = 0;
        rows.forEach(function (row) {
          var on = row.querySelector('.b-toggle').getAttribute('aria-pressed') === 'true';
          if (on) total += parseFloat(row.getAttribute('data-price')) || 0;
        });
        var save = Math.round(total * 0.10);
        var net = total - save;
        if (totalEl) totalEl.textContent = money(net);
        if (ctaTotalEl) ctaTotalEl.textContent = money(net);
        if (saveEl) saveEl.textContent = 'SAVE ' + money(save) + ' (10%)';
      };

      rows.forEach(function (row) {
        var btn = row.querySelector('.b-toggle');
        if (btn.hasAttribute('disabled')) return;
        btn.addEventListener('click', function () {
          var on = btn.getAttribute('aria-pressed') === 'true';
          btn.setAttribute('aria-pressed', on ? 'false' : 'true');
          recompute();
        });
      });
      recompute();
    }

  });
})();
